import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { disabled: boolean }>(
  {
    root: {
      opacity: ({ disabled }) => (disabled ? 0.5 : 1),
    },
    track: {
      height: 36,
      display: 'flex',
      width: '100%',
      opacity: ({ disabled }) => (disabled ? 0.3 : 1),
    },
    trackItem: {
      height: 2,
      width: '100%',
      borderRadius: 4,
    },
    thumbContainer: {
      height: 28,
      width: 28,
      borderRadius: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    thumb: {
      height: 14,
      width: 14,
      borderRadius: '100%',
      border: '1.5px solid #222222',
      background: '#FFFFFF',
    },
  },
  {
    name: 'range-input',
  },
);
export default useStyles;
